import React from 'react';

const Social = () => {
  return (
    <div className="home__social">
        <a href="https://www.instagram.com/keysmissing" 
            className="home__social-icon" 
            target="_blank">
        <i class="uil uil-instagram"></i>
        </a>

        <a href="https://www.linkedin.com/in/rvs1212/" 
        className="home__social-icon" 
        target="_blank">
        <i class="uil uil-linkedin-alt"></i>
        </a>
        

        <a href="https://github.com/rvs1212/" 
        className="home__social-icon" 
        target="_blank">
        <i class="uil uil-github-alt"></i>
        </a>
    </div>
  //  https://iconscout.com/unicons/free-line-icon-fonts/
  );
};

export default Social